import { getEnvVar } from '../../utils/EnvironmentVariables';
import { WebStorageStateStore } from 'oidc-client-ts';

const cognitoDomain = getEnvVar('REACT_APP_COGNITO_DOMAIN');
const clientId = getEnvVar('REACT_APP_CLIENT_ID');
const redirectUri = getEnvVar('REACT_APP_REDIRECT_URI');

const oidcConfig = {
    authority: `https://${cognitoDomain}`,
    client_id: clientId,
    redirect_uri: redirectUri,
    onSigninCallback: () => {
        // Clean up query params but do not navigate away. AuthRoute will redirect after auth completes.
        window.history.replaceState({}, document.title, window.location.pathname);
    },
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    metadata: {
        issuer: `https://${cognitoDomain}`,
        authorization_endpoint: `https://${cognitoDomain}/oauth2/authorize`,
        token_endpoint: `https://${cognitoDomain}/oauth2/token`,
        end_session_endpoint: `https://${cognitoDomain}/logout`,
        jwks_uri: `https://${cognitoDomain}/.well-known/jwks.json`,
        userinfo_endpoint: `https://${cognitoDomain}/oauth2/userInfo`,
    },
};

export default oidcConfig;
